import React from 'react';
import { PaymentContextProvider } from './PaymentContextProvider';

export type PaymentProviderProps = React.PropsWithChildren<{}>;

export const PaymentProvider: React.FC<PaymentProviderProps> = ({ children }) => {
  const [showCheckoutForm, setShowCheckoutForm] = React.useState(false);

  const handleShowCheckoutForm = () => {
    setShowCheckoutForm(true);
  };

  return (
    <PaymentContextProvider
      value={{ showCheckoutForm, setShowCheckoutForm: handleShowCheckoutForm }}
    >
      {children}
    </PaymentContextProvider>
  );
};
